__turbopack_context__.v({
  "activeHistoryBtn": "Assistant-module__Fgqp0a__activeHistoryBtn",
  "assistantContent": "Assistant-module__Fgqp0a__assistantContent",
  "assistantHeader": "Assistant-module__Fgqp0a__assistantHeader",
  "assistantPanel": "Assistant-module__Fgqp0a__assistantPanel",
  "assistantPanelEnter": "Assistant-module__Fgqp0a__assistantPanelEnter",
  "assistantPanelExit": "Assistant-module__Fgqp0a__assistantPanelExit",
  "assistantPanelHidden": "Assistant-module__Fgqp0a__assistantPanelHidden",
  "assistant__disclaimer": "Assistant-module__Fgqp0a__assistant__disclaimer",
  "betaTooltip": "Assistant-module__Fgqp0a__betaTooltip",
  "blink": "Assistant-module__Fgqp0a__blink",
  "chatContainer": "Assistant-module__Fgqp0a__chatContainer",
  "confirmationDialog": "Assistant-module__Fgqp0a__confirmationDialog",
  "confirmationOverlay": "Assistant-module__Fgqp0a__confirmationOverlay",
  "headerIcon": "Assistant-module__Fgqp0a__headerIcon",
  "inputContainer": "Assistant-module__Fgqp0a__inputContainer",
  "inputRow": "Assistant-module__Fgqp0a__inputRow",
  "mainWrapperWithAssistant": "Assistant-module__Fgqp0a__mainWrapperWithAssistant",
  "pulse": "Assistant-module__Fgqp0a__pulse",
  "pulsingIcon": "Assistant-module__Fgqp0a__pulsingIcon",
  "questionsLibraryButton": "Assistant-module__Fgqp0a__questionsLibraryButton",
  "sessionExpiredContainer": "Assistant-module__Fgqp0a__sessionExpiredContainer",
  "slideIn": "Assistant-module__Fgqp0a__slideIn",
  "slideOut": "Assistant-module__Fgqp0a__slideOut",
  "streamingCursor": "Assistant-module__Fgqp0a__streamingCursor",
  "textareaWrapper": "Assistant-module__Fgqp0a__textareaWrapper",
  "tooltipFadeIn": "Assistant-module__Fgqp0a__tooltipFadeIn",
});
